<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h2 class="mt-5">{{ $t("Wochenprogramme") }}</h2>
        <br />
        <p>{{ $t("Erstellen Sie im Handumdrehen neue Wochenprogramme") }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { fetchData } from "./shared/services";
export default {
  name: "app-dashboard",
  data() {
    return {
      dashboardData: {}
    };
  },

  mounted() {
    fetchData().then(res => {
      this.dashboardData = res;
    });
  }
};
</script>

<style lang="scss" scoped></style>
